import React, {memo, useEffect, useState} from 'react';
import {InView} from 'react-intersection-observer';

/* Components */
import VerticalFeaturesSkeleton from './VerticalFeaturesSkeleton';
import HbImageView from '../../../../components/HbImage/view/HbImageView';
import HbPlaceholderFrame from '../../../../components/Placeholder/frame/HbPlaceholderFrame';

/* Utils */
import hydraHomeLazyRequest from '../../../../modules/home/hydraHomeLazyRequest';
import DataSet from '../../../../utils/DataSet';
import {generateUrlForGoogleBot} from '../../../../utils/urlHelper'

/* Hooks */
import {useEffectOnlyOnUpdate} from '../../../../common/react/hook/lifecycle';

/* Styles */
import s from './vertical-features.scss';

const Banner = memo((props) => {
  const {id, image, altText, link, order, name, testId, isBot} = props;
  return (
    <a
      href={link}
      className={s.banner}
      title={name}
      data-test-id={testId}
      data-hbus={DataSet.createDataForDavinci(
        {
          id: id,
          name: altText,
          mediaPath: link
        },
        order,
        'Features',
        'home'
      )}>
      <HbPlaceholderFrame ratio={416 / 182}>
        <HbImageView
          className={s.bannerImage}
          shouldLoadEagerly={isBot}
          image={{
            src: image?.url,
            alt: altText,
            size: '416-182',
            componentSize: {width: '416', height: '182'},
            originSize: {width: image?.width, height: image?.height}
          }}/>
      </HbPlaceholderFrame>
    </a>
  );
});

const VerticalFeatures = memo((props) => {
  const { data, requestParams, componentKey, url, platform, type, index, isBot } = props;
  const [banners, setBanners] = useState(data?.items || []);
  const [loading, setLoading] = useState(false);

  useEffectOnlyOnUpdate(() => {
    setBanners(data?.items);
  }, [data]);

  useEffect(() => {
    if (url && banners?.length === 0) {
      setLoading(true);
      dispatchLazyRequest().then((res) => {
        setLoading(false);
        setBanners(res?.data?.result?.[0]?.data?.items);
      });
    }
  }, []);

  const dispatchLazyRequest = () => {
    return hydraHomeLazyRequest({
      componentKey: componentKey,
      platform: platform,
      ...requestParams
    });
  };

  if (loading || banners?.length === 0) {
    return <VerticalFeaturesSkeleton/>;
  }

  return (
    <InView as="div" data-test-id={`${type}`} className={s.bannerRow}>
      {banners?.map((item, idx) => (
        <Banner
          key={idx}
          testId={`${type}-image-${idx}`}
          index={idx}
          name={item?.name}
          id={item?.id}
          image={item?.image}
          link={generateUrlForGoogleBot({ url: item?.link, isBot })}
          altText={item?.voiceOverText}
          isBot={isBot}
        />
      ))}
    </InView>
  );
});

export default VerticalFeatures;
